import { trackEvent } from 'dibs-tracking';

const defaultTrackingObj = {
    category: 'contact dealer',
    label: 'pdp chat box',
};
export const trackInputFocus = userId =>
    trackEvent({
        ...defaultTrackingObj,
        action: `contact dealer entry - logged ${userId ? 'in' : 'out|unregistered'}`,
    });

export const trackSendClick = userId =>
    trackEvent({
        ...defaultTrackingObj,
        action: `contact dealer send ${userId ? 'clicked' : 'initiated - logged out|unregistered'}`,
    });

export const trackMessageSubmit = wordCount =>
    trackEvent({
        ...defaultTrackingObj,
        value: wordCount,
        action: 'contact dealer submitted',
    });

export const trackCloseClick = () =>
    trackEvent({
        ...defaultTrackingObj,
        action: ' pdp chat box exit',
    });

export const trackMinimizeClick = isMinimized =>
    trackEvent({
        ...defaultTrackingObj,
        action: `pdp chat box ${isMinimized ? 'opened' : 'minimized'}`,
    });

export const trackChatOpen = () => {
    trackEvent({
        ...defaultTrackingObj,
        action: 'pdp chat box displayed',
    });
};
